import { STATUSNOZZLE } from "../../model";

export const optionsStatusTextFieldSelect = [
  {
    value: STATUSNOZZLE.WAITING,
    label: "Aguardando validação",
  },
  { value: STATUSNOZZLE.APPROVED, label: "Concluido" },
  { value: STATUSNOZZLE.BLOCK, label: "Recusado" },
];
